import * as Styled from './Icon.styled'

interface IconProps {
    ref?: React.RefObject<HTMLImageElement>
    src: string
    alt: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    position?: 'absolute' | 'relative' | 'static' | 'fixed' | 'sticky'
    className?: string
}

export const Icon = ({
    ref = undefined,
    src,
    alt,
    size = 'md',
    position = 'relative',
    className,
}: IconProps) => {
    return (
        <Styled.Icon
            ref={ref}
            src={src}
            alt={alt}
            size={size}
            position={position}
            className={className}
        />
    )
}

Icon.displayName = 'Icon'
